<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="strokeWidth"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle
      cx="12"
      cy="10"
      r="3"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconPin',
  props: {
    size: { type: [String, Number], default: 22 },
    strokeWidth: { type: [String, Number], default: 2 },
  },
};
</script>
